"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Person = void 0;
const useStore_entities_1 = require("../../contexts/useStore/useStore.entities");
class Person extends useStore_entities_1.Entity {
    static cache = true;
    static all = () => ({
        api: 'v0',
        method: 'GET',
        route: '/people',
    });
    static update = (attributes) => ({
        api: 'v1',
        content: [
            { op: 'replace', path: '/description', value: attributes['description'] },
            { op: 'replace', path: '/phone_number', value: attributes['phone_number'] },
            { op: 'replace', path: '/staffing_info', value: attributes['staffing_info'] },
            ...attributes['certifications'],
            ...attributes['role'],
        ],
        method: 'PATCH',
        route: '/people/me',
    });
    static affinities = ({ id }) => ({
        api: 'v1',
        method: 'GET',
        route: `/people/${id}/skills_affinities`,
    });
    static sort = (a, b) => a.attributes['nickname'].localeCompare(b.attributes['nickname']);
    getFullName = () => `${this.attributes['nickname']} / ${this.attributes['first_name']} ${this.attributes['last_name']}`;
    match = (nickname) => this.attributes['nickname'].toLocaleLowerCase() === nickname.toLocaleLowerCase();
}
exports.Person = Person;
//# sourceMappingURL=Person.js.map